(() => {
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-ce-brand-tabs]:not(.ce-brand-ready)').forEach(root => {
      const tabs = [...root.querySelectorAll('[role="tab"]')];
      const panels = [...root.querySelectorAll('[role="tabpanel"]')];
      const select = index => {
        tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
        panels.forEach((panel, i) => { panel.hidden = i !== index; });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault(); select(next); tabs[next].focus();
        });
      });
      root.closest('.ce-brand-landing').querySelectorAll('[data-ce-select-range]').forEach(link => {
        link.addEventListener('click', event => {
          event.preventDefault(); const index = Number(link.dataset.ceSelectRange);
          select(index); root.scrollIntoView({behavior: 'smooth', block: 'start'}); tabs[index].focus({preventScroll:true});
        });
      });
      root.classList.add('ce-brand-ready'); select(0);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
